import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import EmailLists from './EmailLists'

import * as S from './styles'

import type { RelatedUsersList } from '@/types/components/Modal/Templates/ShareCollection'

interface ShareResultViewProps {
  result: {
    success?: RelatedUsersList
    error?: RelatedUsersList
  }
  onClose: () => void
  onAddNewEmails: () => void
}

export default function ShareResultView({
  result,
  onClose,
  onAddNewEmails
}: ShareResultViewProps) {
  const { t } = useTranslation()

  const emailLists = useMemo(() => {
    const lists = []

    if (result.success?.length) {
      lists.push({
        key: 'success',
        users: result.success,
        type: 'success',
        title: t('subtitles.successShareCollection')
      })
    }
    if (result.error?.length) {
      lists.push({
        key: 'error',
        users: result.error,
        type: 'error',
        title: t('subtitles.errorShareCollection')
      })
    }

    return lists
  }, [result, t])

  return (
    <S.ShareResultViewContainer>
      <EmailLists lists={emailLists} />

      <S.SharedListButtons>
        <button type="button" onClick={onClose} id={'btn_close_results'}>
          {t('buttons.close')}
        </button>
        <button onClick={onAddNewEmails} type="submit" id="btn_add_new_emails">
          {t('buttons.addNewEmails')}
        </button>
      </S.SharedListButtons>
    </S.ShareResultViewContainer>
  )
}
